"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BlogStore_1 = require("../stores/BlogStore");
const helpers_1 = require("../components/impl/helpers");
const Blog_1 = require("../components/Blog");
class BlogActions {
    static getPosts(context, payload, callback) {
        const postPerPage = (0, helpers_1.getParamValue)(context, 'post per page');
        if (postPerPage) {
            payload.postPerPage = payload.postPerPage || parseInt(postPerPage, 10);
        }
        const blogStore = context.getStore(BlogStore_1.default);
        context.service.read('blogPosts', payload, (err, searchResult) => {
            if (err) {
                callback(err);
                return;
            }
            context.dispatch(BlogStore_1.POSTS_RECIEVED, new Blog_1.BlogContainer(payload, searchResult));
            callback();
        });
    }
    static getCurrentPost(context, payload, callback) {
        context.service.read('post', payload, (err, post) => {
            if (err) {
                callback(err);
                return;
            }
            context.dispatch(BlogStore_1.SINGLE_POST_OPEN, post);
            callback();
        });
    }
    static unmountSinglePost(context, payload, callback) {
        context.dispatch(BlogStore_1.UNMOUNT, {});
        callback();
    }
    static postComment(context, payload, callback) {
        context.service.create('comment', {}, payload, (err, newComment) => {
            if (err) {
                return;
            }
            context.dispatch(BlogStore_1.COMMENT_ADDED, newComment);
            callback();
        });
    }
}
exports.default = BlogActions;
